import { Component, ViewChild, AfterViewInit } from '@angular/core';

import { Dialog, DialogRef } from '../../../../dialog/dialog.base';
import { ToastService } from '../../../../toast/toast.service';

import { CameraComponent } from '../../../../camera/camera.component';

/**
 * @ignore
 */
@Component({
  selector: 'uex-input-file-take-picture-modal',
  templateUrl: './take-picture.modal.html',
  host: {
    class: 'uex-input-file-take-picture-modal'
  }
})
export class InputFileTakePictureModal implements AfterViewInit {
  @ViewChild('camera', { static: true }) camera: CameraComponent;

  constructor(
    private _dialogRef: DialogRef,
    private _toastService: ToastService
  ) {
    this.dialog = this._dialogRef.dialog;
  }

  public dialog: Dialog;

  public ngAfterViewInit() {
    this.camera.onReady.subscribe(status => {
      if (status.error) {
        if (!status.permission) {
          this._toastService.open({
            message: 'Ops... VocÃª nÃ£o autorizou a utilizaÃ§Ã£o da camera.'
          });
        } else if (!status.support) {
          this._toastService.open({
            message: 'Ops... Seu navegador nÃ£o suporta esse recurso.'
          });
        } else {
          this._toastService.open({
            message: 'Ops... Ocorreu um erro desconhecido.'
          });
        }
        this.dialog.close();
      }
    });
  }

  public takePicture() {
    this.dialog.returnValue(this.camera.takePicture());
    this.dialog.close();
  }
}
